export default () => {
  return () => next => action => {
    if (action.type) {
      window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.event &&
        window.webkit.messageHandlers.event.postMessage(JSON.stringify(action));
    }
    return next(action);
  };
};
